import { ADMIN_MODE_STORAGE_KEY, getLocalStorage } from '~/utils/localstorage'

export function useAdminEdit() {
	const isAdmin = useState('isAdmin', () => false)
	const adminMode = useState('adminMode', () => false)

	// https://nuxt.com/docs/4.x/api/advanced/import-meta
	// check if the runtime is done serverside
	if (import.meta.server) {
		const event = useRequestEvent()
		const role = event?.context?.userRole
		isAdmin.value = role === 'admin' || role === 'editor'
	}

	// check if the runtime is done clientside & mounted
	if (import.meta.client) {
		onMounted(() => {
			const storage = getLocalStorage()
			adminMode.value = storage?.getItem(ADMIN_MODE_STORAGE_KEY) === 'true'
		})
	}

	const canEdit = computed(() => isAdmin.value && adminMode.value)

	const toggleAdminMode = () => {
		adminMode.value = !adminMode.value
		const storage = getLocalStorage()
		storage?.setItem(ADMIN_MODE_STORAGE_KEY, String(adminMode.value))
	}

	return { isAdmin, adminMode, canEdit, toggleAdminMode }
}
